import { $, $$, insertHTML } from 'utils/dom';
import { cookieBannerTemplate } from './cookiebanner-template';

export default class Cookiebanner {
  constructor(props) {
    this.cookieName = props.cookieName;
    this.cookieDuration = props.cookieDuration;
    this.cookieTypes = props.cookieTypes;
    this.isProduction =
      window.location.href.includes('helmholtz.de') &&
      !window.location.href.includes('ddev');
    this.cookieOpenerButtons = $$('[data-cookie-opener]');
    this.breakpoint = 768;
  }

  setDefaultAttributes = (resetAll = true) => {
    this.cookieTypes.forEach((cookieType, index) => {
      if (resetAll) {
        cookieType.isChecked = false;
        cookieType.alreadySet = false;
      } else {
        const isSet = this.checkCookie(this.cookieName).includes(
          `cookie-${index}`
        );
        if (isSet) {
          cookieType.isChecked = true;
          cookieType.alreadySet = false;
        }
      }
    });
  };

  renderCookiebanner = (showBannerOnRender = true, isFirstRun = false) => {
    insertHTML(
      $('body'),
      'beforeend',
      cookieBannerTemplate(showBannerOnRender, isFirstRun, this.cookieTypes)
    );

    this.banner = $('.cookiebanner');
    this.configPanel = $('.cookiebanner__config-panel', this.banner);
    this.introPanel = $('.cookiebanner__intro-panel', this.banner);
    this.cookieConfigureButton = $('.cookiebanner__configure');
    this.closeButtons = $$('.cookiebanner__close', this.banner);
    this.cookieCheckboxes = $$('.cookiebanner input[type="checkbox"]');

    this.bindTabEvents();
    this.bindEvents();
    this.bindCloseButtons();
    this.handleBodyScroll();

    this.banner && this.banner.focus();
  };

  handleBodyScroll = () => {
    // disable body scroll on mobile when banner is open
    if (window.innerWidth <= this.breakpoint) {
      const bannerIsHidden = this.banner.classList.contains('is-hidden');
      bannerIsHidden
        ? ($('html').style.overflow = '')
        : ($('html').style.overflow = 'hidden');
    }
  };

  createTrackingScripts = trackingScripts => {
    if (trackingScripts.length) {
      trackingScripts.forEach(tracking => {
        const insertSelector = tracking.insertSelector;

        if (tracking.script) {
          this.createScriptTag(
            'script',
            tracking.script,
            insertSelector,
            tracking.id
          );
        }

        if (tracking.noscript) {
          this.createScriptTag(
            'noscript',
            tracking.noscript,
            insertSelector,
            tracking.id
          );
        }
      });
    }
  };

  createScriptTag = (tagType, script, insertSelector, id) => {
    const newScript = document.createElement(tagType);
    const inlineScript = document.createTextNode(script);

    newScript.appendChild(inlineScript);
    newScript.setAttribute('id', id);
    document.querySelector(insertSelector).appendChild(newScript);
  };

  createCookie = (cookieName, cookieValueObj, cookieDuration) => {
    let expires = '';
    let cookieValue = '';
    const days = cookieDuration;

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toGMTString()}`;
    } else {
      expires = '';
    }

    const valueArray = [];
    Object.entries(cookieValueObj).forEach(item => {
      const key = item[0];
      const value = item[1];
      if (value) valueArray.push(key);
    });

    if (valueArray.length) {
      cookieValue = valueArray.map(value => value).join(',');
    } else {
      cookieValue = 'false';
    }

    document.cookie = `${cookieName}=${cookieValue}${expires}; path=/; samesite=strict`;
  };

  checkCookie = cookieName => {
    const nameEQ = `${cookieName}=`;
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  closeCookiebanner = () => {
    // create the cookie
    this.createCookie(this.cookieName, this.inputObj, this.cookieDuration);

    if (this.isProduction) {
      // check for user consent and handle loading external scripts and videos
      this.handleExternalScripts();

      // reload page
      window.location.reload();
    }

    $('.cookiebanner').classList.add('is-hidden');
    this.handleBodyScroll();
  };

  handleExternalScripts = () => {
    this.cookieTypes.forEach(cookieType => {
      console.log(cookieType);
      if (
        cookieType.subType === 'matomo' &&
        cookieType.alreadySet &&
        !cookieType.isChecked
      ) {
        // if a user withdraws consent, opt out and reload the page so _pk cookies are deleted and mtm_consent_removed cookie is set
        // eslint-disable-next-line no-undef
        _paq.push(['optUserOut']);
      } else if (
        cookieType.subType === 'matomo' &&
        cookieType.alreadySet &&
        cookieType.isChecked
      ) {
        // eslint-disable-next-line no-undef
        _paq.push(['forgetUserOptOut']);
        this.createTrackingScripts(cookieType.trackingScripts);
      }

      if (!cookieType.alreadySet && cookieType.isChecked) {
        if (cookieType.type === 'script') {
          this.createTrackingScripts(cookieType.trackingScripts);
          cookieType.alreadySet = true;
        }
      }
    });
  };

  handleEventTracking = () => {
    const trackingHandlers = $$('[class*="--track-event"]');
    trackingHandlers.forEach(handler => {
      const { type, name, category } = JSON.parse(handler.dataset.tracking);
      const url = window.location.href;

      if (type === 'onclick') {
        handler.addEventListener('click', () => {
          // eslint-disable-next-line no-undef
          _paq.push(['trackEvent', category, url, name]);
        });
      } else if (type === 'onkeydown') {
        handler.addEventListener('keydown', e => {
          if (e.key === 'Enter') {
            // eslint-disable-next-line no-undef
            _paq.push(['trackEvent', category, url, handler.value]);
          }
        });
      }
    });
  };

  bindTabEvents = () => {
    const panels = [this.introPanel, this.configPanel];
    panels.forEach(panel => {
      const focusableElements = $$(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        panel
      );
      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement =
        focusableElements[focusableElements.length - 1];

      panel.addEventListener('keydown', e => {
        const isCheckbox = e.target.getAttribute('type') === 'checkbox';

        // toggle cookie checkboxes via keyboard
        if (e.key === 'Enter' && isCheckbox) {
          e.target.checked = !e.target.checked;
        }

        // trap focus
        if (e.key === 'Tab' && e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        } else if (e.key === 'Tab') {
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            e.preventDefault();
          }
        }
      });
    });
  };

  bindEvents = () => {
    // render cookie configuration panel
    this.cookieConfigureButton.addEventListener('click', () => {
      this.introPanel.classList.add('is-hidden');
      this.configPanel.classList.remove('is-hidden');
    });

    // re-open configuration panel
    this.cookieOpenerButtons.length &&
      this.cookieOpenerButtons.forEach(cookieOpener => {
        cookieOpener.addEventListener('click', () => {
          if (this.banner) {
            this.banner.classList.remove('is-hidden');
            this.handleBodyScroll();
            this.banner.focus();
          }
        });
      });
  };

  bindCloseButtons = () => {
    // close cookiebanner and create cookies
    this.closeButtons.length &&
      this.closeButtons.forEach(closeButton => {
        closeButton.addEventListener('click', () => {
          this.inputObj = {};

          // get value of checkboxes
          this.cookieCheckboxes.length &&
            this.cookieCheckboxes.forEach((checkbox, index) => {
              // check every checkbox if user clicked to "all" button, before closing cookiebanner
              if (closeButton.dataset.confirm === 'all') {
                checkbox.checked = true;
              }
              this.cookieTypes[index].isChecked = checkbox.checked;
              this.inputObj[`${checkbox.id}`] = checkbox.checked;
            });

          this.closeCookiebanner();
        });
      });
  };

  init = () => {
    // check if cookie exists (with the users choice to be tracked or not)
    if (document.cookie.indexOf(this.cookieName) < 0) {
      // if there is none, render the cookiebanner which will ask for his choice
      this.setDefaultAttributes();
      this.renderCookiebanner(true, true);
    } else {
      // if there is a cookie: render hidden cookiebanner so it's available when a user wants to configure his_her settings
      this.setDefaultAttributes(false);

      // create trackingscripts if user allowed analytics cookies
      this.cookieTypes.forEach((cookieType, index) => {
        if (this.checkCookie(this.cookieName).includes(`cookie-${index}`)) {
          if (cookieType.type === 'script') {
            this.createTrackingScripts(cookieType.trackingScripts);
            cookieType.alreadySet = true;
          }
          if (cookieType.subType === 'matomo') {
            this.handleEventTracking(true);
          }
        }
      });

      this.renderCookiebanner(false);
    }
  };
}
